import {
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormControlProps,
} from '@mui/material';
import { useField } from 'formik';

import type { Override } from '@/types/common';

type TFormikCheckboxProps = Override<
  FormControlLabelProps,
  {
    name: string;
    label: string | JSX.Element;
    fieldProps?: FormControlProps;
  }
>;

export const FormikBoolean = ({ fieldProps, ...props }: TFormikCheckboxProps) => {
  const [field, , helpers] = useField<boolean>(props.name);

  const onChange = (event: unknown, checked: boolean) => {
    helpers.setValue(checked);
  };

  return (
    <FormControl {...fieldProps}>
      <FormControlLabel checked={field.value} onChange={onChange} {...props} />
    </FormControl>
  );
};
